// Import firebase services
import { firebaseAuth } from '@/firebase/firebase-config'

export const BugsnagService = {

	/*
	**  Set the methods
	*/

	methods: {

		reportAuthBugsnagError(metaData) {

			if (metaData) {

				// Send to bugsnag
				bugsnagClient.metaData = {
					Title: metaData.title,
					ErrorType: metaData.errorType,
					Section: metaData.section,
					UID: metaData.uid,
					Component: this.$options.name,
					Data: this.$data,
					Route: this.$route,
					User: {
						ID: firebaseAuth.currentUser.uid,
						Name: firebaseAuth.currentUser.displayName,
						Email: firebaseAuth.currentUser.email
					}
				};

				// Notify Bugsnag
				bugsnagClient.notify(metaData.error);

			}

		},

		reportNoAuthBugsnagError(metaData) {

			if (metaData) {

				// Send to bugsnag
				bugsnagClient.metaData = {
					Title: metaData.title,
					ErrorType: metaData.errorType,
					Section: metaData.section,
					UID: metaData.uid,
					Component: this.$options.name,
					Data: this.$data,
					Route: this.$route
				};

				// Notify Bugsnag
				bugsnagClient.notify(metaData.error);

			}

		},

		reportCustomBugsnagError(metaData) {

			if (metaData) {

				// Send to bugsnag
				bugsnagClient.metaData = {
					Title: metaData.title,
					ErrorType: metaData.errorType,
					Section: metaData.section,
					UID: metaData.uid,
					Component: this.$options.name,
					Data: this.$data,
					Route: this.$route,
					Custom: metaData.custom
				};

				// Notify Bugsnag
				bugsnagClient.notify(metaData.error);

			}

		}

	}

}